"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const colors_1 = __importDefault(require("../../styles/colors"));
const styles = react_native_1.StyleSheet.create({
    mainContainer: {
        flex: 1,
        paddingTop: 0,
        paddingBottom: 0,
        backgroundColor: colors_1.default.COLOR_GRAY_LIGHTER,
    },
    mainHomeContainer: {
        flex: 1,
        paddingTop: 0,
        paddingBottom: 0,
        backgroundColor: colors_1.default.COLOR_WHITE,
        flexDirection: 'column',
        flexGrow: 1,
        justifyContent: 'space-between',
    },
});
exports.default = styles;
